import styled from 'styled-components';

import 'antd/lib/spin/style/index.css';
import 'antd/lib/tooltip/style/index.css';

export const PageTitle = styled.div`
  margin: 0 auto 30px auto;
  width: auto;
  max-width: 1068px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  div:nth-child(2){
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 10px;
  }
  div.headerInline {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  p {
    margin-left: 10px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: 0.01px;
    color: #999999;
    span {
      text-transform: capitalize;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.21;
      letter-spacing: 0.01px;
      color: #74a50a;
    }
  }
  span {
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.28;
    letter-spacing: 0.01px;
    text-align: left;
    color: #619b30;
  }
  div.voltar {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-right: 20px;
    padding-top: 2px;
    button {
      display: flex;
      align-items: center;
      flex-direction: row;
      border: none;
      background: none;
      color: #619b30;
      font-weight: bold;
    }
  }
`;

export const BoxContent = styled.div`
  width: 1068px;
  min-height: 400px;
  padding: 20px 10px;
  margin: 0 auto;
  border: solid 0.8px #ebebeb;
  background-color: #f9f9f9;
  div.boxSpin {
    display: flex;
    justify-content: center;
    padding: 50px;
  }
`;

export const BoxContentHeader = styled.div`
  /* padding: 10px 30px; */
  display: flex;
  align-self: center;
  height: 30px;
  div {
    display: flex;
    flex-direction: row;
    align-items: center;
    min-width: 170px;
    svg {
      color: #b4b4b4;
      margin-left: 5px;
    }

    span {
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 13px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.23;
      letter-spacing: 0.01px;
      color: #727272;
    }
  }
  div.indicadoresHeader {
    width: 520px;
    padding-left: 30px;
  }
  div.coletaHeader {
    width: 153px;
    display: flex;

    justify-content: center;
  }
  div.statusHeader {
    display: flex;
    justify-content: center;
    width: 219px;
  }
`;

export const BoxList = styled.div`
  div.BoxListItems {
    width: '100%';
    height: 70px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    background-color: #ffffff;

    margin-top: 15px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    color: #235f6e;

    div.indicador {
      width: 500px;
      padding-left: 30px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;

      font-size: 13px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.15;
      letter-spacing: 0.46px;
      color: #235f6e;

      button {
        background-color: transparent;
        border: none;
      }
    }
    div.coleta {
      width: 150px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.15;
      letter-spacing: 0.01px;
      color: #999999;
    }
    div.status {
      width: 220px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      > span {
        color: #74a50a;
        font-size: 13px;
      }
    }
  }

  div.BoxListCompetences {
    padding: 30px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    background-color: #ededed;
    position: relative;
    div.verticalLine {
      width: 0;
      min-height: 94px;
      border: solid 1px #235f6e;
      position: absolute;
      top: -25px;
      left: 40px;
    }
    div.monthsComp {
      width: 100%;

      margin-left: 20px;

      div.monthsCompHeader {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        font-size: 11px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1;
        letter-spacing: 0.01px;
        color: #999999;
        margin-top: -10px;

        div.monthsCompHeader_child {
          &:first-child {
            display: flex;
            flex-direction: row;
            padding-left: 45px;
          }
          .status_competencia {
            padding-left: 230px;
          }
          &:last-child {
            display: flex;
            flex-direction: row;
            padding-right: 30px;
            > span {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
            }
          }
        }
      }
      div.monthsCompList {
        border-bottom: solid 1px rgba(35, 95, 110, 0.1);
      }

      div.monthsCompList + div:before {
        content: '';
        width: 2px;
        background-color: #235f6e;
        height: 55px;
        position: absolute;
        left: 40px;
        margin-top: -38px;
      }

      div.monthsCompList {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;

        padding-top: 10px;
        padding-bottom: 10px;
        margin-left: 34px;
        margin-right: 20px;
        div.monthItem {
          width: 320px;
          display: flex;
          align-items: center;
          span {
            font-size: 12px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.25;
            letter-spacing: 0.01px;
            text-align: left;
            color: #235f6e;
            position: relative;
          }
          span:before {
            content: ' ';
            display: block;
            width: 29px;
            height: 2;
            border: solid 1px #235f6e;
            position: absolute;
            left: -58px;
            top: 7px;
          }
        }

        div.monthMessage {
          font-size: 12px;
          width: 200px;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.25;
          letter-spacing: normal;
          text-align: left;
          color: #cc0000;
          display: flex;
          align-items: center;
          padding-right: 22px;
          strong {
            font-weight: 700;
          }
        }
        div.monthButton {
          font-size: 13px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.15;
          letter-spacing: normal;
          text-align: center;
          color: #ffffff;
          button {
            padding: 0 12px;
            height: 32px;
            border-radius: 3.5px;
            background-color: #74a50a;
            color: #fff;
            border: none;
            &:disabled {
              background-color: #e2e2e2;
              color: #bababa;
              cursor: not-allowed;
            }
          }
        }
      }
    }

    div.dataColetaFooter {
      margin-top: 20px;
      padding-right: 18px;
      height: 40px;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;

      span {
        font-size: 11px;
        line-height: 12px;
        letter-spacing: 0px;
        text-align: left;
        color: #999999;
      }
      input {
        width: 118px;
        height: 35px;
        background: #ffffff;
        border: 0;
        border-radius: 4px;
        box-shadow: inset 0px 1px 0px 0px #c7c7c794;
        border: solid 1px #c7c7c794;
        padding: 0 10px;
        margin-left: 5px;

        font-size: 13px;
        font-weight: 500;

        text-align: left;
        color: #999999;

        &::placeholder {
          font-size: 13px;
          font-weight: 500;

          text-align: left;
          color: #999999;
        }

        &:disabled {
          background: #f0f0f0;
          box-shadow: inset 0px 1px 0px 0px #c7c7c7;
          &::placeholder {
            color: #f0f0f0;
          }
        }
      }

      button.edit {
        width: 77px;
        height: 35px;
        border-radius: 3.5px;
        border: none;
        background-color: #235f6e;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        svg {
          margin-right: 5px;
        }
      }

      div {
        margin-left: 15px;
      }
    }

    div.dataColetaFooterOff {
      margin-top: 10px;
      padding-right: 18px;
      height: 20px;
    }
  }
`;

export const MonthStatus = styled.div`
  width: 180px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: 0.01px;
  text-align: left;
  color: ${props =>
    (props.status === 'O' && '#d9b100 ') ||
    (props.status === 'A' && '#d9b100 ') ||
    (props.status === 'CN' && '#999999 ') ||
    (props.status === 'C' && '#74a50a ')};
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ButtonStatus = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 9px;
  background-color: ${props =>
    (props.status === 'O' && '') ||
    (props.status === 'A' && '') ||
    (props.status === 'CN' && '#999999') ||
    (props.status === 'C' && '#74a50a') ||
    (props.status === 'A' && '#f9cb00')};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
  svg {
    color: ${props => (props.status === 'O' ? '#f9cb00' : '#fff')};
  }
`;

export const ButtonList = styled.div`
  width: 21px;
  height: 21px;
  border-radius: 3px;
  border: solid 0.5px
    ${props =>
      props.monthsCompVisible ||
      props.monthsCompVisibleAVC ||
      props.monthsCompVisibleAQ ||
      props.monthsCompVisibleCM ||
      props.monthsCompVisibleCP ||
      props.monthsCompVisibleSCS ||
      props.monthsCompVisibleSCA
        ? '#4c7c88 '
        : '#d8d8d8'};
  background-color: ${props =>
    props.monthsCompVisible ||
    props.monthsCompVisibleAVC ||
    props.monthsCompVisibleAQ ||
    props.monthsCompVisibleCM ||
    props.monthsCompVisibleCP ||
    props.monthsCompVisibleSCS ||
    props.monthsCompVisibleSCA
      ? '#235f6e'
      : '#FFF'};
  margin-right: 20px;
  svg {
    color: ${props =>
      props.monthsCompVisible ||
      props.monthsCompVisibleAVC ||
      props.monthsCompVisibleAQ ||
      props.monthsCompVisibleCM ||
      props.monthsCompVisibleCP ||
      props.monthsCompVisibleSCS ||
      props.monthsCompVisibleSCA
        ? '#FFF'
        : '#999999'};
  }
`;

export const SwitchButton = styled.div`
  .ant-switch {
    min-width: 53px;
    height: 26px;
    line-height: 23px;
    margin-right: 10px;
  }
  .ant-switch-checked {
    background-color: #74a50a;
  }

  .ant-switch-loading-icon,
  .ant-switch::after {
    width: 22px;
    height: 22px;
  }
  &::selection {
    color: #fff;
    background: #74a50a;
  }
  > span {
    color: #74a50a;
    font-size: 13px;
  }
`;

export const BoxPagination = styled.div`
  padding: 40px 30px 30px 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  ul {
    color: #235f6e;
    a {
      color: #235f6e;
      font-size: 13px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: 0.01px;

      svg {
        margin-bottom: -8px;
      }
    }

    a.arrowLeft {
      display: inline-block;
      margin-right: 70px;
    }
    a.arrowRight {
      display: inline-block;
      margin-left: 70px;
    }

    li.ant-pagination-item {
      border: none;
      background-color: transparent;
      width: 26px;
      min-width: 26px;
      height: 26px;
      line-height: 24px;
      a {
        font-size: 13px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: 0.01px;
        color: #235f6e;
      }
    }
    li.ant-pagination-item-active {
      background-color: #74a50a;
      border-radius: 0;
      a {
        color: #fff;
      }
    }
  }
`;

export const BoxButtonSave = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  text-align: center;
  button {
    height: 34px;
    padding: 0 5px;
    border-radius: 3.5px;
    background-color: #74a50a;
    border: none;
    color: #fff;
  }
`;

export const NoContent = styled.div`
  width: 100%;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  p {
    font-size: 14px;
    color: #ccc;
  }
  svg {
    color: #ccc;
    margin-bottom: 10px;
  }
`;
